import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import api from '../utils/api';
import { useAuth } from '../App';
import { useLocation } from 'react-router-dom';
import { isPublicRoute } from '../utils/publicRoutes';

const OFFICE_ROLES = ['admin', 'customer_service', 'bookings_operator'];

export default function PromoActivationPopup() {
  const { user } = useAuth();
  const location = useLocation();
  const publicPage = isPublicRoute(location.pathname);
  const criticalAutonomyWorkflow = location.pathname.startsWith('/admin/autonomia-hwsmart') || location.pathname.startsWith('/admin/accounting-control');
  const popupSuppressedRoute = criticalAutonomyWorkflow
    || location.pathname.startsWith('/company-profiles')
    || location.pathname.startsWith('/properties');
  const [ready, setReady] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (publicPage || popupSuppressedRoute) { setReady([]); setOpen(false); return; }
    if (!user || !OFFICE_ROLES.includes(user.role)) return;
    if (window.location.pathname.startsWith('/promozioni')) return;
    api.get('/promotions/partner-requests').then(r => {
      const list = (r.data?.requests || []).filter(x => x.status === 'pending' && x.can_approve);
      if (list.length) { setReady(list); setOpen(true); }
    }).catch(() => {});
  }, [user, publicPage, popupSuppressedRoute]);

  if (publicPage || popupSuppressedRoute || !ready.length) return null;
  return (
    <Dialog modal={false} open={open} onOpenChange={setOpen}>
      <DialogContent hideOverlay className="!left-auto !right-3 !top-auto !bottom-3 !w-[calc(100%-1.5rem)] !max-w-md !translate-x-0 !translate-y-0 border-amber-200 shadow-2xl sm:!right-5 sm:!bottom-5" data-testid="promo-activation-popup">
        <DialogHeader><DialogTitle>🔔 Promozioni da attivare</DialogTitle></DialogHeader>
        <DialogDescription className="text-sm text-slate-600">
          {ready.length === 1 ? "C'è 1 richiesta partner pronta da lavorare" : `Ci sono ${ready.length} richieste partner pronte da lavorare`}
          {' '}(24 ore trascorse senza blocco del proprietario). Questo avviso comparirà a ogni ingresso finché non vengono attivate.
        </DialogDescription>
        <ul className="space-y-1 max-h-48 overflow-y-auto">
          {ready.map(r => (
            <li key={r.id} className="text-sm border rounded-lg px-3 py-2 flex items-center justify-between gap-2" data-testid={`promo-popup-item-${r.id}`}>
              <span><b>{r.property_name}</b> <span className="text-blue-700 font-bold">-{r.pct}%</span>
                {r.type === 'cancel' && <span className="ml-1 text-[10px] bg-rose-100 text-rose-700 px-1 rounded font-semibold">ANNULLO</span>}</span>
              <span className="text-xs text-slate-400 whitespace-nowrap">{r.partner_name}</span>
            </li>))}
        </ul>
        <div className="flex gap-2 justify-end pt-2">
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="promo-popup-later">Più tardi</Button>
          <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="promo-popup-go"
            onClick={() => { window.location.href = '/promozioni?tab=da-attivare'; }}>
            Vai ad attivare
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
